dmx.Actions({
  'f7.preloader.show' (options) {
    Framework7.instance.preloader.show();
  },
  
  'f7.preloader.hide' (options) {
    Framework7.instance.preloader.hide();
  },
});